module.exports = __webpack_public_path__ + "static/media/16UNODC31.850b6df2.jpg";